import { render, staticRenderFns } from "./SubCollectionTile.vue?vue&type=template&id=1d13aef8&scoped=true&lang=pug&"
import script from "./SubCollectionTile.vue?vue&type=script&lang=js&"
export * from "./SubCollectionTile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d13aef8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d13aef8')) {
      api.createRecord('1d13aef8', component.options)
    } else {
      api.reload('1d13aef8', component.options)
    }
    module.hot.accept("./SubCollectionTile.vue?vue&type=template&id=1d13aef8&scoped=true&lang=pug&", function () {
      api.rerender('1d13aef8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/collection/SubCollectionTile.vue"
export default component.exports